var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-8 -8 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6457 2.39623L15.6197 8.28883L21.3438 8.85596C21.48 8.86728 21.6102 8.91742 21.7188 9.00043C21.8275 9.08345 21.9101 9.19586 21.9569 9.32437C22.0036 9.45288 22.0126 9.59209 21.9827 9.72554C21.9528 9.85898 21.8853 9.98106 21.7882 10.0773L17.0774 14.7468L18.8239 21.0918C18.8597 21.2264 18.8558 21.3685 18.8127 21.5009C18.7696 21.6333 18.6892 21.7504 18.5811 21.8382C18.4731 21.926 18.3419 21.9807 18.2035 21.9958C18.0651 22.0108 17.9253 21.9855 17.8009 21.923L11.9978 19.0491L6.20265 21.9194C6.07826 21.982 5.93845 22.0073 5.80003 21.9922C5.66161 21.9772 5.53048 21.9225 5.42241 21.8347C5.31434 21.7469 5.23393 21.6297 5.19086 21.4973C5.14779 21.3649 5.14388 21.2229 5.17962 21.0883L6.92615 14.7432L2.21184 10.0738C2.11472 9.9775 2.04721 9.85542 2.01731 9.72198C1.98742 9.58854 1.99638 9.44932 2.04314 9.32082C2.08989 9.19231 2.17249 9.07989 2.28115 8.99688C2.38981 8.91386 2.51998 8.86372 2.65625 8.8524L8.38027 8.28527L11.3498 2.39623C11.4109 2.27694 11.5037 2.17682 11.618 2.10691C11.7324 2.03699 11.8638 2 11.9978 2C12.1318 2 12.2632 2.03699 12.3775 2.10691C12.4918 2.17682 12.5847 2.27694 12.6457 2.39623V2.39623Z",
    stroke: "#7E898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/StarOutlined.89c96834d2da14ccccf7d5377cd986d7.svg";
export { ForwardRef as ReactComponent };